exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex-grow: 1;\r\n}\r\n\r\n.kendo-tab-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    height: 100%;\r\n}\r\n\r\n.filter-form {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.label-col-1 {\r\n    flex: 0 0 160px;\r\n    min-width: 160px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n}\r\n\r\n.label-col-2 {\r\n    flex: 0 0 220px;\r\n    min-width: 220px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n}\r\n\r\n.kendo-grid {\r\n    height:100%;\r\n    overflow: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/settings/settings-cashreg/settings-cashreg.component.css
// module id = 2377
// module chunks = 1